import { type IConfigurationCardEntry } from './ConfigurationCardContext.tsx';

/**
 * Le card si registrano via `useEffect` con un push in coda: una card che
 * diventa visibile dopo il primo render (perché la sua visibilità dipende
 * dalla configurazione) finirebbe in fondo all'ordine di registrazione anche
 * se nel DOM sta in mezzo. Riordiniamo in base alla posizione DOM reale.
 *
 * Usata sia dall'Anchor (ordine voci) sia dallo stacking sticky (offset top per
 * indice della card principale).
 */
export function sortEntriesByDomOrder(
  entries: IConfigurationCardEntry[],
): IConfigurationCardEntry[] {
  if (typeof document === 'undefined' || entries.length <= 1) return entries;

  const indexMap = new Map<string, number>();
  entries.forEach((entry, index) => indexMap.set(entry.id, index));

  return [...entries].sort((a, b) => {
    const aElement = document.getElementById(a.id);
    const bElement = document.getElementById(b.id);
    if (aElement == null || bElement == null) {
      const aIndex = indexMap.get(a.id) ?? 0;
      const bIndex = indexMap.get(b.id) ?? 0;
      return aIndex - bIndex;
    }
    const pos = aElement.compareDocumentPosition(bElement);
    if ((pos & Node.DOCUMENT_POSITION_FOLLOWING) !== 0) return -1;
    if ((pos & Node.DOCUMENT_POSITION_PRECEDING) !== 0) return 1;
    return 0;
  });
}
